import setup from './moduleSetup';

export default {
    name: 'integrations',
    before: [],
    after: [],
    setup,
};
